'use client';

import { BlogBanner } from './BlogBanner';
import { BlogNews } from './BlogNews';
export const Blog: React.FC = () => {
  return <>
      <BlogBanner />
      <BlogNews />
    </>;
};